import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import { motion } from 'framer-motion';
import {StyledPageContainer, StyledFormContainer, StyledImageContainer, StyledFormContent, StyledFormContainerChild} from './StyledPageContainer';
import {ReactComponent as LogoSvgImage} from '../../../../static/images/auth/withless-logo.svg';


const fadeVariants = {
  initial: { opacity: 0, scale: 0.98 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.98 },
};

const FadeTransition = ({ children, duration = 0.3, ...rest }) => {
  return (
    <motion.div
      variants={fadeVariants}
      initial="initial"
      animate="animate"
      transition={{ duration, ease: 'easeInOut' }}
      style={{width: '100%' }}
      exit='hidden'
      {...rest}
    >
      {children}
    </motion.div>
  );
};

const PageContainer = ({formContent, imageContent, ...rest}) => {

  return (
    <StyledPageContainer {...rest}>
      <StyledFormContainer className='page-form-content-container'>
        <StyledFormContainerChild>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link to='/' className='main-page-link'>
            <LogoSvgImage />
          </Link>
          <StyledFormContent className='form-content-container'>
            {formContent}
          </StyledFormContent>
        </StyledFormContainerChild>
      </StyledFormContainer>
      <StyledImageContainer className='image-content-container'>
        {imageContent}
      </StyledImageContainer>
    </StyledPageContainer>
  );
}

PageContainer.propTypes = {
  formContent: PropTypes.any,
  imageContent: PropTypes.any,
};

export {
  PageContainer,
  FadeTransition
};
